import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import { TimeInput } from '@/components/Input/TimeInput';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@e2n/ui';
import { maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoTimeOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

// eslint-disable-next-line max-lines-per-function
export function FieldTimeInput({
  label,
  description,
  placeholder,
  isRequired,
  className,
  suffix,
  ...inputProps
}: FieldProps &
  React.ComponentProps<typeof TimeInput> & {
    suffix?: string;
  }) {
  const timeOptions = maskitoTimeOptionsGenerator({
    mode: 'HH:MM',
    timeSegmentMaxValues: { hours: 23 },
  });
  const options = {
    ...timeOptions,
    plugins: [
      ...timeOptions.plugins,
      maskitoEventHandler('blur', (element) => {
        const [hours = '', minutes = ''] = element.value.split(':');
        if (hours === '' && minutes === '') return;
        maskitoUpdateElement(
          element,
          [hours, minutes].map((segment) => segment.padEnd(2, '0')).join(':'),
        );
      }),
    ],
  };
  const field = useFieldContext<string>();
  const maskito = useMaskito({ options });

  return (
    <FieldBase
      label={label}
      description={description}
      isRequired={isRequired}
      className={className}>
      <InputGroup>
        <InputGroupInput
          id={field.name}
          name={field.name}
          ref={maskito}
          value={field.state.value}
          onChange={(e) => field.handleChange(e.target.value)}
          onBlur={field.handleBlur}
          placeholder={placeholder ?? '--:--'}
          type="text"
          {...inputProps}
        />
        {suffix && (
          <InputGroupAddon
            className="text-neutrals-700 text-sm font-normal leading-5"
            align={'inline-end'}>
            {suffix}
          </InputGroupAddon>
        )}
      </InputGroup>
    </FieldBase>
  );
}
